var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_120_36667",
    style: {
      "maskType": "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3051 12.3075L10.9083 2.4726C10.7272 2.18287 10.4826 1.93818 10.1928 1.7571C9.13907 1.0985 7.75093 1.41884 7.09233 2.4726L1.69552 12.3075C1.47202 12.6651 1.35352 13.0783 1.35352 13.5C1.35352 14.7426 2.36087 15.75 3.60352 15.75H14.3971C14.8188 15.75 15.232 15.6315 15.5896 15.408C16.6434 14.7494 16.9637 13.3613 16.3051 12.3075ZM9.63633 3.2676C9.57597 3.17102 9.49441 3.08946 9.39783 3.0291C9.04658 2.80956 8.58386 2.91634 8.36433 3.2676L2.96752 13.1025C2.89302 13.2217 2.85352 13.3594 2.85352 13.5C2.85352 13.9142 3.1893 14.25 3.60352 14.25H14.3971C14.5377 14.25 14.6754 14.2105 14.7946 14.136C15.1459 13.9165 15.2527 13.4538 15.0331 13.1025L9.63633 3.2676ZM8.25033 9C8.25033 9.41421 8.58612 9.75 9.00033 9.75C9.41454 9.75 9.75033 9.41421 9.75033 9V6C9.75033 5.58579 9.41454 5.25 9.00033 5.25C8.58612 5.25 8.25033 5.58579 8.25033 6V9ZM9.75033 12C9.75033 11.5858 9.41454 11.25 9.00033 11.25C8.58612 11.25 8.25033 11.5858 8.25033 12C8.25033 12.4142 8.58612 12.75 9.00033 12.75C9.41454 12.75 9.75033 12.4142 9.75033 12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_120_36667)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "black"
  }))));
};

export default __webpack_public_path__ + "static/media/icon-catalog-warning.9c476ed0.svg";
export { SvgComponent as ReactComponent };